import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=4f49aa85&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=4f49aa85&prod&lang=scss&scoped=true"
import style1 from "./DocumentList.vue?vue&type=style&index=1&id=4f49aa85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49aa85",
  null
  
)

export default component.exports